



















import { Component, Emit } from 'vue-property-decorator'
import { Swipe, SwipeItem } from 'vant'
import { SuperMixin } from '../../category.mixin'
import { namespace } from 'vuex-class'
import { includes, filter, toArray, uniq, flatten } from 'lodash'
import { getSelectedCityId } from '@utils/index'
import { getItemTypeList } from '../../category.service'


const categoryModule = namespace('category')

@Component({
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
})
export default class RecoveryComponent extends SuperMixin {
  selected = 0
  showIndex = 9
  itemType1List: any = [] //项目类型1
  itemType2List: any = [] //项目类型2

  @categoryModule.State grayscale!: any
  @categoryModule.State categoryList!: any[]
  @categoryModule.State itemTypeList!: any[]
  @categoryModule.Action getCMSAction!: (par: any) => Promise<any>
  @categoryModule.State cmsData!: any

  get bannerData() {
    return this.cmsData
  }

  get isGrayScale() {
    return this.categoryIds && includes(this.grayscale, this.categoryIds.join(','))
  }

  get tagList() {
    const itemTypeList = filter(this.itemTypeList,(item:any) => {
      return item.isType1 ? includes(this.itemType1List,item.itemType) : includes(this.itemType2List,item.itemType)
    })
    const list = itemTypeList && itemTypeList.length > 0 ? [{ itemType: '全部', isAll: true }, ...itemTypeList] : []
    return list
  }

  get showTagMore() {
    return this.tagList.length > 9 && this.showIndex < 10
  }

  get showMoreBtn(){
    return this.tagList.length > 9
  }

  async created() {
    const cityId = getSelectedCityId(false) //城市编码
    const params = {
      citycode: cityId,
      types: 103,
    }
    this.getCMSAction(params)
    this.queryItem()
  }
  async queryItem() {
    const response: ResponseCode = await getItemTypeList(this.categoryIds)
    if (response && response.code == 1) {
      const list = toArray(response.data)
      this.itemType1List = uniq(
        flatten(list.map((item: any) => {
          return item.itemType1
        }))
      )
      this.itemType2List = uniq(
        flatten(list.map((item: any) => {
          return item.itemType2
        }))
      )
    }
  }
  clickItem(item: any) {
    location.href = item.link
  }
  showAllTag() {
    this.showIndex = this.showIndex === 9 ? Infinity : 9
  }

  @Emit()
  changeTag(item: any, index: number) {
    this.selected = index
    return item
  }
}
